// libs
import React, { memo } from "react";
import { css } from "@emotion/core";

// global components
import WithStyles from "shared/components/WithStyles";

// constants
import { NAV_BUTTON, CAROUSEL_TYPE } from "shared/components/Carousel/constants";

// styles
const navCss = css`
    background: transparent;
    border: 0;
    font-weight: 600;
    font-size: 1.14rem;

    &.next {
        transform: rotate(180deg);
    }

    &.ver-next {
        transform: rotate(270deg);
    }

    &.ver-prev {
        transform: rotate(90deg);
    }

    &.disabled {
        color: #bfbfbf;
    }
`;

interface INavButtonProps {
    type: NAV_BUTTON;
    oritentation: CAROUSEL_TYPE;
    isDisabled: boolean;
}

function NavButton({ type, oritentation, isDisabled }: INavButtonProps) {
    const isVertical = oritentation === CAROUSEL_TYPE.VERTICAL;

    const navClassName = [
        "icon-arrow",
        isVertical === false && type === NAV_BUTTON.NEXT && "next",
        isVertical && type === NAV_BUTTON.NEXT && "ver-next",
        isVertical && type === NAV_BUTTON.PREV && "ver-prev",
        isDisabled && "disabled",
    ]
        .filter(Boolean)
        .join(" ");

    return <WithStyles as="i" cssProps={navCss} className={navClassName} />;
}

export default memo(NavButton);
